export const GIF_ASSETS = {
    // Bottom bar
    walking_start: 'walking_start.gif',
    walking_continous: 'walking_continuos.gif',
    walking_end: 'walking_end.gif',
    waving: 'waving.gif',
    waving_2: 'waving_2.gif',
    waving_3: 'waving_3.gif',
    // Inline
    welcome: 'welcome.gif',
    standing_one: 'standing_one.gif',
    standing_two: 'standing_two.gif',
    thinking: 'thinking.gif',
    typing_start: 'typing_start.gif',
    typing_continuos: 'typing_continuos.gif',
    listening_start: 'listening_start.gif',
    listening_continous: 'listening_continous.gif',
    listening_end: 'listening_end.gif',
    speaking: 'speaking.gif',
};
export function getAllAssetPaths(assetsBasePath, mode) {
    const paths = [];
    if (mode === 'bottom-bar') {
        paths.push(`${assetsBasePath}/${GIF_ASSETS.walking_start}`, `${assetsBasePath}/${GIF_ASSETS.walking_continous}`, `${assetsBasePath}/${GIF_ASSETS.walking_end}`, `${assetsBasePath}/${GIF_ASSETS.waving}`, `${assetsBasePath}/${GIF_ASSETS.waving_2}`, `${assetsBasePath}/${GIF_ASSETS.waving_3}`, `${assetsBasePath}/${GIF_ASSETS.standing_one}`, `${assetsBasePath}/${GIF_ASSETS.standing_two}`);
    }
    else {
        paths.push(`${assetsBasePath}/${GIF_ASSETS.welcome}`, `${assetsBasePath}/${GIF_ASSETS.standing_one}`, `${assetsBasePath}/${GIF_ASSETS.standing_two}`, `${assetsBasePath}/${GIF_ASSETS.thinking}`, `${assetsBasePath}/${GIF_ASSETS.typing_start}`, `${assetsBasePath}/${GIF_ASSETS.typing_continuos}`, `${assetsBasePath}/${GIF_ASSETS.listening_start}`, `${assetsBasePath}/${GIF_ASSETS.listening_continous}`, `${assetsBasePath}/${GIF_ASSETS.listening_end}`, `${assetsBasePath}/${GIF_ASSETS.speaking}`);
    }
    return paths;
}
export function preloadImages(paths, onComplete) {
    const images = new Map();
    let loadedCount = 0;
    const total = paths.length;
    if (total === 0) {
        onComplete(images);
        return;
    }
    paths.forEach((path) => {
        const img = new Image();
        const filename = path.split('/').pop() || path;
        img.onload = () => {
            images.set(filename, img);
            loadedCount++;
            if (loadedCount === total) {
                onComplete(images);
            }
        };
        img.onerror = () => {
            // Continue even if some images fail to load
            loadedCount++;
            if (loadedCount === total) {
                onComplete(images);
            }
        };
        img.src = path;
    });
}
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
